import { connect } from 'react-redux';
import { focusCommentEditor } from '../../../DeviationPage/redux/actions';
const mapDispatchToProps = {
    onFocusCommentEditor: focusCommentEditor
};
export default connect(undefined, mapDispatchToProps);

//# sourceMappingURL=CommentButton.container.js.map